export const APPROVAL_GAS_LIMIT = 80_000;
export const QUOTE_CACHE_TTL = 10_000;
export const EXACT_OUT_ALLOWANCE_TRESHOLD = 0.05;
